import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { isAuthenticated, user, isLoading } = useAuth();
    const location = useLocation();
    const canAccessAdminPortal = Boolean(user?.isStaff ?? user?.is_staff);
    if (isLoading) {
        return _jsx("div", { children: "Loading..." });
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/account/login", state: { from: location }, replace: true });
    }
    if (requireAdmin && !canAccessAdminPortal) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
